import api from "@/lib/api";

const KEY = "cck_visitor_v1";

// Records one listing/profile click (server dedups per visitor per day).
export function trackView(targetType, targetId) {
  if (!targetId) return;
  let visitor = sessionStorage.getItem(KEY);
  if (!visitor) {
    visitor = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(KEY, visitor);
  }
  api.post("/track/view", { target_type: targetType, target_id: targetId, visitor_key: visitor }).catch(() => {});
}
